import { render, staticRenderFns } from "./gNotification.vue?vue&type=template&id=f8a8de4a&scoped=true&"
import script from "./gNotification.vue?vue&type=script&lang=js&"
export * from "./gNotification.vue?vue&type=script&lang=js&"
import style0 from "./gNotification.vue?vue&type=style&index=0&id=f8a8de4a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8a8de4a",
  null
  
)

export default component.exports